import { PickOBNotification } from "../../../Home/reducers/onBoardingUI";

// A partir de la fecha (21 de enero de 2025), ya no se procesan en CRM1
export interface OBNotificationStore extends PickOBNotification {}

export const obNotificationStore: (state) => OBNotificationStore = state => {
  const { onBoardingUI } = state;
  return {
    notification: onBoardingUI.notification
  };
};
